import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";

const setMeta = (attr, key, value) => {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", value);
};

const setJsonLd = (id, data) => {
  let el = document.getElementById(id);
  if (!data) { el?.remove(); return; }
  if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.id = id; document.head.appendChild(el); }
  el.textContent = JSON.stringify(data);
};

export const Seo = () => {
  const { content } = useSite();
  useEffect(() => {
    const { seo = {}, product: p, brand = {}, faqs = [] } = content;
    const origin = window.location.origin;
    const url = `${origin}${window.location.pathname === "/diabetes-pro" ? "/diabetes-pro" : "/"}`;
    const image = seo.og_image?.startsWith("http") ? seo.og_image : `${origin}${seo.og_image || ""}`;
    document.title = seo.title || p.name;
    setMeta("name", "description", seo.description);
    setMeta("property", "og:title", seo.title);
    setMeta("property", "og:description", seo.description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("name", "twitter:title", seo.title);
    setMeta("name", "twitter:description", seo.description);
    setMeta("name", "twitter:image", image);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = url;
    let alt = document.head.querySelector('link[rel="alternate"][hreflang="hi"]');
    if (!alt) { alt = document.createElement("link"); alt.rel = "alternate"; alt.hreflang = "hi"; document.head.appendChild(alt); }
    alt.href = `${url}?lang=hi`;

    // Product schema uses only admin-supplied facts: no ratings, reviews or health claims.
    setJsonLd("ld-product", p?.name && p?.price ? {
      "@context": "https://schema.org", "@type": "Product", name: p.name, image: [image], description: p.subcopy,
      sku: p.id, category: p.category, brand: { "@type": "Brand", name: brand.brand_name },
      offers: { "@type": "Offer", price: String(p.price), priceCurrency: p.currency || "INR", availability: "https://schema.org/InStock", url },
    } : null);
    setJsonLd("ld-faq", faqs.length ? {
      "@context": "https://schema.org", "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    } : null);
  }, [content]);
  return null;
};
